import { useCallback } from "react";
import { useJanusStreaming, StreamingVideo } from "../../lib/janus-react-streaming";
import { useAuth } from "../../contexts/authContext";

export default function StreamPage() {
  const { userData } = useAuth();
  const token = userData?.accessToken;

  const config = {
    server: "/proxy",
    headers: () => (token ? { Token: token } : {}),
    debug: false,
  };

  const {
    connectionState,
    iceState,
    streams,
    mediaStream,
    stats,
    error,
    activeStreamId,
    connect,
    watch,
    stop,
    disconnect,
    clearError,
  } = useJanusStreaming(config);

  const handleConnect = useCallback(async () => {
    clearError();
    await connect();
  }, [connect, clearError]);

  const handleWatch = useCallback(async (id) => {
    clearError();
    await watch({ id });
  }, [watch, clearError]);

  if (!token) {
    return <div style={{ padding: 24 }}>Please log in to view streams.</div>;
  }

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 16 }}>Live Stream</h2>

      <div style={{ marginBottom: 16, display: "flex", gap: 8, alignItems: "center" }}>
        <span>Status: <strong>{connectionState}</strong></span>
        {iceState !== "new" && <span> | ICE: <strong>{iceState}</strong></span>}
        {stats && <span> | {Math.round(stats.bitrate / 1024)} kbps</span>}
      </div>

      {error && (
        <div style={{ padding: 12, background: "#fee", color: "#c00", borderRadius: 8, marginBottom: 16 }}>
          {error.message} <button onClick={clearError} style={{ marginLeft: 8 }}>Dismiss</button>
        </div>
      )}

      {connectionState === "disconnected" && (
        <button onClick={handleConnect} style={{ padding: "8px 24px", fontSize: 16 }}>Connect</button>
      )}

      {(connectionState === "attached" || connectionState === "streaming") && streams.length > 0 && (
        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
          {streams.map((s) => (
            <button
              key={s.id}
              onClick={() => handleWatch(s.id)}
              disabled={activeStreamId === s.id}
              style={{ padding: "6px 16px" }}
            >
              {s.description || `Stream ${s.id}`} {activeStreamId === s.id ? "(watching)" : ""}
            </button>
          ))}
        </div>
      )}

      {mediaStream && (
        <StreamingVideo stream={mediaStream} style={{ width: "100%", maxWidth: 800, borderRadius: 8, background: "#000" }} />
      )}

      {connectionState !== "disconnected" && (
        <button onClick={disconnect} style={{ marginTop: 16, padding: "6px 16px" }}>Disconnect</button>
      )}
    </div>
  );
}
